import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * State and actions
 */

type State = {
  dependentes: PaginationProperties,
  eventos: PaginationProperties,
  ferias: PaginationProperties,
  afastamentos: PaginationProperties,
  documentos: PaginationProperties,
  documentosEntregues: PaginationProperties,
  treinamentos: PaginationProperties,
  habilidades: PaginationProperties,
  habilidadeItems: PaginationProperties,
  controlePatrimonios: PaginationProperties,
  centroCustoSecundarios: PaginationProperties,
  biometriaFacial: PaginationProperties,
};

type Action = {
  dependentesSetter: SetPaginationProperties,
  eventosSetter: SetPaginationProperties,
  feriasSetter: SetPaginationProperties,
  afastamentosSetter: SetPaginationProperties,
  documentosSetter: SetPaginationProperties,
  documentosEntreguesSetter: SetPaginationProperties,
  treinamentosSetter: SetPaginationProperties,
  habilidadesSetter: SetPaginationProperties,
  habilidadeItemsSetter: SetPaginationProperties,
  controlePatrimoniosSetter: SetPaginationProperties,
  centroCustoSecundariosSetter: SetPaginationProperties,
  biometriaFacialSetter: SetPaginationProperties,
};

/**
 * usePagination
 */

export const usePagination = create<State & Action>((set) => ({
  dependentes: InitializePaginationProperties({ rowsPerPage: 5 }),
  dependentesSetter: InitializeSetPaginationProperties(set, 'dependentes'),

  eventos: InitializePaginationProperties({ rowsPerPage: 5 }),
  eventosSetter: InitializeSetPaginationProperties(set, 'eventos'),

  ferias: InitializePaginationProperties({ rowsPerPage: 5 }),
  feriasSetter: InitializeSetPaginationProperties(set, 'ferias'),

  afastamentos: InitializePaginationProperties({ rowsPerPage: 5 }),
  afastamentosSetter: InitializeSetPaginationProperties(set, 'afastamentos'),

  documentos: InitializePaginationProperties(),
  documentosSetter: InitializeSetPaginationProperties(set, 'documentos'),

  documentosEntregues: InitializePaginationProperties({ rowsPerPage: 100 }),
  documentosEntreguesSetter: InitializeSetPaginationProperties(set, 'documentosEntregues'),

  treinamentos: InitializePaginationProperties(),
  treinamentosSetter: InitializeSetPaginationProperties(set, 'treinamentos'),

  habilidades: InitializePaginationProperties(),
  habilidadesSetter: InitializeSetPaginationProperties(set, 'habilidades'),

  habilidadeItems: InitializePaginationProperties({ rowsPerPage: 100 }),
  habilidadeItemsSetter: InitializeSetPaginationProperties(set, 'habilidadeItems'),

  controlePatrimonios: InitializePaginationProperties(),
  controlePatrimoniosSetter: InitializeSetPaginationProperties(set, 'controlePatrimonios'),

  centroCustoSecundarios: InitializePaginationProperties({ rowsPerPage: 5 }),
  centroCustoSecundariosSetter: InitializeSetPaginationProperties(set, 'centroCustoSecundarios'),

  biometriaFacial: InitializePaginationProperties({ rowsPerPage: 5 }),
  biometriaFacialSetter: InitializeSetPaginationProperties(set, 'biometriaFacial'),
}));

